export interface ICustomDivider {
  style?: React.CSSProperties;
}

export const CustomDivider = ({ style = {} }: ICustomDivider) => {
  return (
    <div
      aria-hidden='true'
      style={{
        margin: '0 16px',
        borderTop: '1px solid #D1D6D9',
        position: 'absolute',
        width: 'calc(100% - 32px)',
        bottom: 0,
        left: '0',
        ...style,
      }}
    />
  );
};
